module.exports = function(app) {
    app.directive('claimStatus', ['$filter', function($filter) {

        return {
            restrict: 'A',
            replace: true,

            scope: {
                statusCode: '=',
                claimType: '=',
                providerName: '='
            },

            template:   '<ul class="claim-icons">' +
                            '<li class="approval-icon"><span class="hm-icon {{status.icon}}"></span><span>{{status.description}}</span></li>' +
                            '<li><span class="hm-icon {{planIcon}} status-plan-icon"></span><span>{{providerName}}</span></li>' +
                        '</ul>',

            controller: ['$scope', function($scope) {

                var getPlanIcon = function(claimType) {
                    claimType = claimType || '';

                    if (claimType==='dental') {
                        return 'icon-dental';
                    }
                    else if (claimType==='vision') {
                        return 'icon-vision';
                    }
                    else if (claimType==='ods') {
                        return 'icon-pharmacy';
                    }
                    else if (claimType==='medical') {
                        return 'icon-provider';
                    }
                    else {
                        return '';
                    }
                };

                var getClaimStatus = function(statusCode, scope) {
                    statusCode = statusCode
                        ? String(statusCode)
                        : '';

                    scope = scope || {};

                    var status = scope.status || {};

                    switch (statusCode) {
                        case '1':
                            status.description = 'Approved';
                            status.icon = 'icon-approved';
                            break;

                        case '2':
                            status.description = 'Partially Approved';
                            status.icon = 'icon-alert mhs-icon';
                            break;

                        case '3':
                            status.description = 'Denied';
                            status.icon = 'icon-denied';
                            break;

                        case '4':
                            status.description = 'Adjusted';
                            status.icon = 'icon-adjusted-claim';
                            break;

                        case '5':
                            status.description = 'In Process';
                            status.icon = 'icon-in-process';
                            break;

                        default:
                            status.description = 'Info Not Available';
                            status.icon = '';
                    }
                    return status;
                };

                var getProviderName = function(providerName) {
                    return providerName
                        ? $filter('capitalize')(providerName)
                        : 'Provider Name Unavailable';
                };

                $scope.$watch(
                    function(scope) {
                        return scope.claimType;
                    },
                    function(newVal) {
                        $scope.planIcon = getPlanIcon(newVal);
                    }
                );

                $scope.$watch(
                    function(scope) {
                        return scope.providerName;
                    },
                    function(newVal) {
                        $scope.providerName = getProviderName(newVal);
                    }
                );

                $scope.$watch(
                    function(scope) {
                        return scope.statusCode;
                    },
                    function(newVal) {
                        $scope.status = getClaimStatus(newVal, $scope);
                    }
                );
            }]
        };
    }]);
}